import React, { useState, useEffect } from "react"
import { useDispatch } from "react-redux"

import { haveAuth } from "utils"
import { editOfflineOrder } from "@redux"
import OfflineOrderDetailsHeader from "./OfflineOrderDetailsHeader"
import OfflineOrderDetailsFooter from "./OfflineOrderDetailsFooter"
import OfflineOrderDetailsItems from "./OfflineOrderDetailsItems"
import OfflineOrderDetailDropdown from "./OfflineOrderDetailDropdown"
import OfflineOrderDetailsCustomerInfo from "./OfflineOrderDetailsCustomerInfo"
import OfflineOrderDetailsCheckoutButton from "./OfflineOrderDetailsCheckoutButton"
import OfflineOrderDetailsEditButton from "./OfflineOrderDetailsEditButton"

import classes from "./index.module.scss"

const OfflineOrderDetails = props => {
  const { offlineOrder: initialOfflineOrder } = props

  const dispatch = useDispatch()

  const [offlineOrder, setOfflineOrder] = useState(initialOfflineOrder)

  const orderViewed = () => {
    dispatch(
      editOfflineOrder(
        offlineOrder.offlineOrderId,
        { isViewed: true }
      )
    )
  }

  useEffect(() => {
    orderViewed()
  }, [])

  const showCheckoutButton =
    haveAuth(["checkout"]) &&
    offlineOrder.deliveryType !== "delivery" &&
    offlineOrder.orderStatus === "pending"

  const showEditButton =
    haveAuth(["editOrder"]) &&
    offlineOrder.deliveryType !== "delivery" &&
    offlineOrder.orderStatus === "pending"

  return (
    <div className={classes["container"]}>
      <div className={classes["wrapper"]}>
        <OfflineOrderDetailDropdown
          offlineOrder={offlineOrder}
          setOfflineOrder={setOfflineOrder}
        />

        <OfflineOrderDetailsCustomerInfo
          offlineOrder={offlineOrder}
        />

        <OfflineOrderDetailsHeader
          offlineOrder={offlineOrder}
        />

        <OfflineOrderDetailsItems
          offlineOrder={offlineOrder}
        />
        <OfflineOrderDetailsFooter
          offlineOrder={offlineOrder}
        />
      </div>

      {
        showCheckoutButton &&
        <div className={classes["buttons"]}>
          {
            showEditButton &&
            <OfflineOrderDetailsEditButton
              offlineOrder={offlineOrder}
            />
          }
          <OfflineOrderDetailsCheckoutButton
            offlineOrder={offlineOrder}
          />
        </div>
      }
    </div>
  )
}

export default OfflineOrderDetails